import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useIsConfluenceContactCompanyExpandEligible } from "@/components/user-context";
import { FeatureExposed } from "@/utils/feature-exposed";
import {
    FreeForTenUsersText,
    Headings,
    WelcomeBackText
} from "../../../components";

export const ExistingUser = () => {
    const useContactExpandCohortLogic =
        useIsConfluenceContactCompanyExpandEligible();

    return (
        <FeatureExposed
            experimentKey="cfind-3467-signup-with-image-overlay"
            group="isTreatment"
        >
            <ConfluenceOverlayTemplate size="sm">
                <Headings
                    main={<WelcomeBackText />}
                    sub={<FreeForTenUsersText />}
                />
                <SiteActivation
                    useContactExpandCohortLogic={useContactExpandCohortLogic}
                />
            </ConfluenceOverlayTemplate>
        </FeatureExposed>
    );
};
